import React, {useEffect, useRef} from "react";
import "./Lifter.css";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

function Lifter(){

const wrapper = useRef(null);
const Lifter = useRef(null);
const H1 = useRef(null);

   useEffect(()=>{
        const ctx = gsap.context(()=>{
            let tl = gsap.timeline({
                scrollTrigger: {
                  trigger: wrapper.current,
                  pin: true,
                  start: "top top",
                  end: "+=300%",
                  scrub: true,
                }
              })
            tl.to(
                H1.current,
                {backgroundImage: "linear-gradient(160deg,#ff93b9,#5e1ceb)",ease:"power1.ease",fontSize:"8vh"}, "+=0.3")
            tl.to(
                Lifter.current,{backgroundColor: "white", ease: "power1.ease"}, ">")
            tl.to(
                H1.current,
                {backgroundImage: "linear-gradient(180deg,#ff93b9,#5e1ceb)", ease:"power1.ease", yPercent:-160}, ">")
            tl.scrollTrigger.refresh();
          });
          return () => ctx.revert();
        },[]);

    return(
        <>
        <div className="wrapper" ref={wrapper}>
        <div className="Lifter" ref={Lifter}>
            <h1 ref={H1}>Specialized Lifting Device</h1>
        </div>
        </div>
        </>
    )
}

export default Lifter